import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator, IndicatorInput } from "../indicator/indicator";
import LinkedList from "../Utils/FixedSizeLinkedList";
export var WilliamsRInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(WilliamsRInput, _IndicatorInput);

  function WilliamsRInput() {
    _classCallCheck(this, WilliamsRInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(WilliamsRInput).apply(this, arguments));
  }

  return WilliamsRInput;
}(IndicatorInput);
export var WilliamsR =
/*#__PURE__*/
function (_Indicator) {
  _inherits(WilliamsR, _Indicator);

  function WilliamsR(input) {
    var _this;

    _classCallCheck(this, WilliamsR);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WilliamsR).call(this, input));
    var lows = input.low;
    var highs = input.high;
    var closes = input.close;
    var period = input.period;
    var format = _this.format;

    if (!(lows.length === highs.length && highs.length === closes.length)) {
      throw new Error("Inputs(low,high, close) not of equal size");
    }

    _this.result = []; // %R = (Highest High - Close)/(Highest High - Lowest Low) * -100
    // Lowest Low = lowest low for the look-back period
    // Highest High = highest high for the look-back period
    // %R is multiplied by -100 correct the inversion and move the decimal.

    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var index, pastHighPeriods, pastLowPeriods, periodLow, periodHigh, tick, williamsR;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              index = 1;
              pastHighPeriods = new LinkedList(period, true, false);
              pastLowPeriods = new LinkedList(period, false, true);
              _context.next = 5;
              return;

            case 5:
              tick = _context.sent;

            case 6:
              if (!true) {
                _context.next = 23;
                break;
              }

              pastHighPeriods.push(tick.high);
              pastLowPeriods.push(tick.low);

              if (!(index < period)) {
                _context.next = 15;
                break;
              }

              index++;
              _context.next = 13;
              return;

            case 13:
              tick = _context.sent;
              return _context.abrupt("continue", 6);

            case 15:
              periodLow = pastLowPeriods.periodLow;
              periodHigh = pastHighPeriods.periodHigh;
              williamsR = format((periodHigh - tick.close) / (periodHigh - periodLow) * -100);
              _context.next = 20;
              return williamsR;

            case 20:
              tick = _context.sent;
              _context.next = 6;
              break;

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this.generator.next();

    lows.forEach(function (low, index) {
      var result = _this.generator.next({
        high: highs[index],
        low: lows[index],
        close: closes[index]
      });

      if (result.value !== undefined) {
        _this.result.push(result.value);
      }
    });
    return _this;
  }

  _createClass(WilliamsR, [{
    key: "nextValue",
    value: function nextValue(price) {
      var nextResult = this.generator.next(price);

      if (nextResult.value !== undefined) {
        return this.format(nextResult.value);
      }
    }
  }]);

  return WilliamsR;
}(Indicator);
WilliamsR.calculate = williamsr;
export function williamsr(input) {
  Indicator.reverseInputs(input);
  var result = new WilliamsR(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}